import React from "react";
import IcomoonReact from "icomoon-react";
import iconSet from "../../fonts/selection.json";
import * as S from "./Documents.sc";
import { convertDate, convertTime } from "../../services/date";
import { getRelativePathFromTap } from "../../services/urlString";

const Documents = ({ files }) => {
  return (
    <S.Container>
      <S.Header>Wzory dokumentów</S.Header>
      <S.List>
        {files.map((el) => (
          <S.ListLi key={`document${el.pk}`} id={el.pk}>
            <IcomoonReact iconSet={iconSet} size={32} icon={"pdf"} />
            <S.Link href={getRelativePathFromTap(el.file)} download>
              <S.Title>{el.name}</S.Title>
              <S.Description>
                Dokument aktualny na:
                {` ${convertDate(el.date)} ${convertTime(el.date)}`}
              </S.Description>
            </S.Link>
          </S.ListLi>
        ))}
      </S.List>
    </S.Container>
  );
};

export default Documents;
